import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['footer'];
  static values = {
    expandedLeft: Number,
    collapsedLeft: Number,
    hiddenLeft: Number,
  };

  connect() {
    this.expandedLeftValue = parseInt(this.footerTarget.dataset.footerExpandedLeft) || 260;
    this.collapsedLeftValue = parseInt(this.footerTarget.dataset.footerCollapsedLeft) || 80;
    this.hiddenLeftValue = parseInt(this.footerTarget.dataset.footerHiddenLeft) || 0;

    // Initialize position
    this.updateFooterPosition();
    this.setupObservers();

    // Debug log
    console.log('QuestionAI Footer controller connected', {
      expanded: this.expandedLeftValue,
      collapsed: this.collapsedLeftValue,
      hidden: this.hiddenLeftValue,
    });
  }

  disconnect() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  setupObservers() {
    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) {
      console.warn('Sidebar element not found');
      return;
    }

    // Listen to sidebar class changes
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        console.log('Sidebar class changed:', mutation.target.className);
      });
      this.updateFooterPosition();
    });

    this.mutationObserver.observe(sidebar, {
      attributes: true,
      attributeFilter: ['class'],
    });

    // Listen to window resize
    this.resizeHandler = () => this.updateFooterPosition();
    window.addEventListener('resize', this.resizeHandler);

    // Listen to jQuery toggle events
    if (typeof $ !== 'undefined') {
      $(document).on('click', '[data-action*="sidebar--controller#toggle"]', () => {
        setTimeout(() => this.updateFooterPosition(), 50);
      });
    }

    // Also listen to direct clicks on sidebar toggle
    const sidebarToggle = document.querySelector('[data-action*="sidebar--controller#toggle"]');
    if (sidebarToggle) {
      sidebarToggle.addEventListener('click', () => {
        setTimeout(() => this.updateFooterPosition(), 100);
      });
    }
  }

  updateFooterPosition() {
    if (!this.hasFooterTarget) return;

    const sidebar = document.querySelector('.sidebar');
    if (!sidebar) return;

    const isCollapsed = sidebar.classList.contains('sidebar-collapsed');
    const isHidden = sidebar.classList.contains('tw-hidden');
    const isMobile = window.innerWidth <= 576;

    let leftPosition;
    if (isMobile) {
      leftPosition = this.hiddenLeftValue;
    } else if (isHidden) {
      leftPosition = this.hiddenLeftValue;
    } else if (isCollapsed) {
      leftPosition = this.collapsedLeftValue;
    } else {
      leftPosition = this.expandedLeftValue;
    }

    console.log('Updating footer position:', {
      isCollapsed,
      isHidden,
      isMobile,
      leftPosition,
    });

    // Remove existing left positioning classes
    this.footerTarget.classList.remove('tw-left-0', 'tw-left-20', 'tw-left-32', 'tw-left-64');

    // Clear any existing inline styles
    this.footerTarget.style.removeProperty('left');

    // Apply new positioning using inline styles for precise control
    this.footerTarget.style.left = `${leftPosition}px`;
    this.footerTarget.style.right = '0px';
  }
}
